export const CHAT_SERVICE_MODE = {
    CHAT_AGENT: 'chat-agent',
    CHATKIT: 'chatkit',
};
